import { Reveal } from "./Reveal";

const TIMELINE = [
  {
    year: "2018",
    title: "Qadvance is born",
    body: "Founded in Argentina to connect QA, Testing, Project Management and Functional Analyst profiles with challenging projects across Latam.",
  },
  {
    year: "2020",
    title: "First projects abroad",
    body: "Client demand pushed us to cover every IT profile, and to start our first projects in the US and Spain.",
  },
  {
    year: "2021",
    title: "Qadvance Uruguay",
    body: "A second hub, created to run our growing international projects more smoothly.",
  },
  {
    year: "2023",
    title: "Focus on the US",
    body: "US projects became our core. Qadvance USA opened to give clients local support and simpler administration.",
  },
  {
    year: "2025",
    title: "The nearcore idea",
    body: "AI reshaped what US teams need. We started building a narrower, deeply specialized offer, and the team and tools behind it.",
  },
  {
    year: "2026",
    title: "nearcore launches",
    body: "Incorporated in Delaware, USA. One focus: senior Data and Cloud engineers for US teams.",
  },
];

export default function History() {
  return (
    <section id="history" className="bg-brand-mist/60 py-14 sm:py-20" data-testid="history-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <p className="text-center font-cond text-xs font-bold uppercase tracking-[0.28em] text-brand-orange">
            Our History
          </p>
          <h2 className="mx-auto mt-4 max-w-3xl text-center font-display text-3xl font-extrabold leading-tight text-brand-teal sm:text-4xl">
            Eight years connecting Latam talent with projects that matter.
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-center text-sm leading-relaxed text-brand-slate sm:text-base">
            nearcore didn't start from a pitch deck. It grew out of Qadvance, the staffing company
            our founders built in Argentina in 2018, and out of everything we learned placing
            engineers with teams in Latin America, Spain and the US.
          </p>
        </Reveal>

        <div className="mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-4 lg:grid lg:grid-cols-6 lg:overflow-visible lg:pb-0" data-testid="history-timeline">
          {TIMELINE.map((t, i) => {
            const isLaunch = i === TIMELINE.length - 1;
            const isIdea = i === TIMELINE.length - 2;
            return (
              <Reveal key={t.year} delay={Math.min(i, 5) * 0.07} className="min-w-[230px] snap-start lg:min-w-0">
                <article
                  data-testid={`history-card-${t.year}`}
                  className={`flex h-full flex-col rounded-2xl border-t-4 p-6 shadow-sm ${
                    isLaunch
                      ? "border-brand-orange bg-[#03383F]"
                      : isIdea
                        ? "border-brand-teal bg-white"
                        : "border-brand-orange bg-white"
                  }`}
                >
                  <p className={`font-display text-3xl font-extrabold ${isLaunch ? "text-white" : "text-brand-orange"}`}>
                    {t.year}
                  </p>
                  <h3 className={`mt-3 font-display text-sm font-bold leading-snug ${isLaunch ? "text-white" : "text-brand-teal"}`}>
                    {t.title}
                  </h3>
                  <p className={`mt-2 text-xs leading-relaxed sm:text-[13px] ${isLaunch ? "text-white/80" : "text-brand-slate"}`}>
                    {t.body}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="mt-10 text-center font-display text-lg font-bold text-brand-teal sm:text-xl">
            Same people. Same standards. A sharper focus.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
